var styles = {"containerCard":"styles_container-card__XyvOE"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
